import { post, get, del, put } from './requests'

export const getTomorrowItems = key => id =>
  get(['api', `tomorrowItems?sectionId=${id || 100}`], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })

export const setTomorrowItemsOrder = key => payload =>
  post(
    ['api', 'tomorrowItems', 'order'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const deleteTomorrowItem = key => payload =>
  del(
    ['api', 'tomorrowItems', 'remove'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const createTomorrowItem = key => payload =>
  post(
    ['api', 'tomorrowItems'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const updateTomorrowItem = key => payload =>
  put(
    ['api', 'tomorrowItems', 'update'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )

export const checkTomorrowItem = key => payload => {
  const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone
  return post(
    ['api', 'tomorrowItems', 'check'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    { timeZoneId, ...payload }
  )
}

export const undoTomorrowItem = key =>
  post(['api', 'tomorrowItems', 'undo'], {
    removeTrailingSlash: true,
    headers: { Authorization: `Bearer ${key}` },
  })



// WEBPACK FOOTER //
// ./src/services/tomorrow-items.js